<template>
  <div class="guide-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to="/guide/guideitem">报考指南</shBreadItem>
      <shBreadItem v-if="guideData.length"
        ><div class="bread">{{ guideData[0]?.guName }}</div></shBreadItem
      >
    </shBread>
  </div>
  <div class="guide">
    <div class="detail" v-for="item in guideData" :key="item.guID">
      <div class="title">
        <h2>
          {{ item.guName }}
        </h2>
        <hr />
      </div>
      <div class="content">
        <div class="con-top">
          <p>作者/来源：{{ item.guAuthor }}</p>
          <p>时间：{{ item.updateAt }}</p>
        </div>
        <div class="con-detail" v-html="item.guBody"></div>
      </div>
    </div>
    <div class="guide-rvideo">
      <VideoRecommend :VideoReCommend="VideoReCommend" />
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { findGuideDetail } from "@/api/news";
import { useRoute, useRouter } from "vue-router";
import { findVideoRecommand, findVideoRandom } from "@/api/video";
import VideoRecommend from "@/components/video-recommend.vue";
export default {
  components: { VideoRecommend },
  setup() {
    const guideData = ref([]);
    const route = useRoute();
    const VideoReCommend = ref([]);
    findGuideDetail(route.query.guID).then((data) => {
      //console.log(data);
      guideData.value = data;
    });

    if (route.query.clID) {
      //这里有两个clID的时候用，分割使其变成数组
      findVideoRecommand(route.query.clID.split(",")).then((data) => {
        //console.log(data);
        VideoReCommend.value = data.map((item) => {
          return {
            chID: item.chID,
            maID: item.maID,
            coID: item.coID,
            clID: item.clID,
            leName: item.leName,
            leImg:"/web/" + item.leImg,
            coverImg:"/web/" + item.coverImg,
            grade: item.grade.find((ele) => ele._id == item.gradeID),
            id: item._id,
          };
        });
      });
    } else {
      findVideoRandom(10).then((data) => {
        VideoReCommend.value = data.map((item) => {
          return {
            chID: item.chID,
            maID: item.maID,
            coID: item.coID,
            clID: item.clID,
            leName:"/web/" + item.leName,
            leImg:"/web/" + item.leImg,
            coverImg: item.coverImg,
            grade: item.grade.find((ele) => ele._id == item.gradeID),
            id: item._id,
          };
        });
      });
    }

    return { guideData, VideoReCommend };
  },
};
</script>

<style lang="less" scoped>
.guide-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.guide {
  width: 1240px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .detail {
    width: 850px;
    background: #fff;
    .title {
      h2 {
        line-height: 30px;
        text-align: center;
        padding-left: 5px;
        padding-right: 5px;
      }
      hr {
        border: #f5f5f5 solid 1px;
      }
    }
    .content {
      .con-top {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        p {
          padding-left: 35px;
          color: #777;
        }
      }
      .con-detail {
        width: 850px;
        align-items: center;
        padding: 15px 15px 20px 15px;
      }
    }
  }
  .line-rvideo {
    width: 350px;
  }
}
</style>
